import React, { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandInput, CommandList, CommandEmpty, CommandItem } from "@/components/ui/command";
import { ChevronsUpDown, Check } from "lucide-react";
import { TYPES } from "./constants";

export default function ItemCombobox({ items, value, onChange, placeholder = "Choisir un article", testid, withPrice, eur }) {
  const [open, setOpen] = useState(false);
  const selected = items.find((i) => i.id === value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid} role="combobox" aria-expanded={open}
          className="flex h-10 flex-1 items-center justify-between rounded-md border border-zinc-800 bg-zinc-900 px-3 text-sm text-white">
          <span className={selected ? "truncate" : "truncate text-zinc-500"}>{selected ? selected.name : placeholder}</span>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-[var(--radix-popover-trigger-width)] min-w-[240px] border-zinc-800 bg-zinc-900 p-0">
        <Command className="bg-zinc-900">
          <CommandInput data-testid={testid ? `${testid}-input` : undefined} placeholder="Taper le nom d'un article…" className="text-white" />
          <CommandList>
            <CommandEmpty className="text-zinc-500">Aucun article trouvé.</CommandEmpty>
            {items.map((i) => (
              <CommandItem key={i.id} value={`${i.name} ${i.id}`} onSelect={() => { onChange(i.id); setOpen(false); }}
                className="text-zinc-200 aria-selected:bg-zinc-800">
                <Check className={`mr-2 h-4 w-4 ${value === i.id ? "text-[#FF6A00] opacity-100" : "opacity-0"}`} />
                <span className="flex-1 truncate">{TYPES[i.type || "materiel"]} · {i.name}{withPrice && eur ? ` — ${eur(i.price)}` : ""}</span>
              </CommandItem>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
